module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, window, $) {
	'use strict';

	fox.registerWidget('Control_Input_McStyled', {

		configure: function (options) {

			this.registerOptions('', {
				container: '.input-container',
				template: 'control_input_mcStyled',
				'templateOptions.value': '',
				type: 'input',
				stateClasses: {
					inactive: 'inactive',
					error: 'error',
					empty: 'empty',
					focus: 'focused',
					tooltipError: 'visible'
				},
				'handleDom.focus': {
					target: '.field',
					event: 'focus',
					callback: '_handleFocus'
				},
				'handleDom.blur': {
					target: '.field',
					event: 'blur',
					callback: '_handleBlur'
				},
				// 'handleDom.input': {
				// 	target: '.field',
				// 	//event: 'input',
				// 	event: ['blur', 'keyup', 'paste', 'input'],
				// 	callback: '_handleInputChange'
				// }
			});

			this.callParent('configure', arguments);
		},

		addedToDom: function() {

			//Need to fix, cause IE doesn't fire `input` event on [contententeditable] elements
			$('.field').on('keyup paste input', function(e){
				this._handleInputChange(e);
			}.bind(this));
		},

		getInputElement: function () {
			return this.dom1('.field');
		},

		getValue: function () {
			var val = this.getInputElement().innerText;

			if (this.getOption('type') === 'input') {
				val = val.replace('\n', '');
			}

			return val;
		},

		_setValue: function (val) {
			this.getInputElement().innerText = val;
			this.setTemplateOptions('value', val);
		},

		setValue: function(val) {
			this.callParent('setValue', arguments);

			this.toggleEmptyState(val.length > 0);
		},

		_handleFocus: function(el, w, alias, e) {
			fox.dom.addClass(this.getOption('stateClasses.focus'), el.parentNode);
			this.toggleError(false);
		},

		_handleBlur: function(el, w, alias, e) {
			this.toggleEmptyState((this.getValue().length > 0));

			fox.dom.removeClass(this.getOption('stateClasses.focus'), el.parentNode);
		},

		_handleInputChange: function(e) {
			//this.callParent('_handleInputChange', arguments);

			//console.log(e.type);

			this.toggleEmptyState((this.getValue().length > 0));
		},

		toggleEmptyState: function(state) {
			fox.dom[state ? 'removeClass' : 'addClass'](this.getOption('stateClasses.empty'), this.getInputElement().parentNode);
		},

		enable: function() {
			this.getInputElement().contentEditable = true;
			fox.dom.removeClass(this.getOption('stateClasses.inactive'), this.getInputElement().parentNode);
			this.setTemplateOptions('inactive', false);
		},

		disable: function() {
			this.getInputElement().contentEditable = false;
			fox.dom.addClass('inactive', this.getInputElement().parentNode);
			this.setTemplateOptions('inactive', true);
		},

		toggleError: function(state, str) {
			var msg = str || '';
			var p = this.getInputElement().parentNode;
			var tooltip = fox.dom.selectFirst('.tooltip', p);

			fox.dom[state ? 'addClass' : 'removeClass'](this.getOption('stateClasses.error'), this.getInputElement().parentNode);

			if (state === true && msg) {
				fox.dom.selectFirst('.message', p).innerText = msg;
				fox.dom.addClass(this.getOption('stateClasses.tooltipError'), tooltip);

				return;
			}

			fox.dom.selectFirst('.message', p).innerText = '';
			fox.dom.removeClass(this.getOption('stateClasses.tooltipError'), tooltip);
		}

	}, 'Control_Input');

})(fox, window, fox.jQuery);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/controls/input/mcStyled.js
// module id = 302
// module chunks = 2